import React, { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Header.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faChevronLeft, faChevronRight, faSearch, faUser, faBars, faTimes, faUserGraduate, faCertificate, faRocket } from '@fortawesome/free-solid-svg-icons';
// import Landing from '../images/Webpage design-02-01-01.png';
import Landing from '../images/landing.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Header = () => {

    useEffect(() => {
        document.title = 'OCP';

        AOS.init({
            duration: 1000, // animation duration in ms
            once: true,     // whether animation should happen only once
        });
    }, []);

    const handleScroll = () => {
        const section = document.getElementById("courses");
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };


    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isSearchVisible, setIsSearchVisible] = useState(false);
    const [enrolledCount, setEnrolledCount] = useState(0);
    const [certifiedCount, setCertifiedCount] = useState(0);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
        if (isSearchVisible) setIsSearchVisible(false);
    };

    const toggleSearch = () => {
        setIsSearchVisible(!isSearchVisible);
        if (isMenuOpen) setIsMenuOpen(false);
    };

    useEffect(() => {
        // Target numbers for counters
        const targetEnrolled = 1100;
        const targetCertified = 500;
        const duration = 2000; // Animation duration in ms
        const increment = 50; // Time between increments in ms

        // Calculate steps needed
        const enrolledSteps = Math.ceil(duration / increment);
        const certifiedSteps = Math.ceil(duration / increment);

        // Calculate increment per step
        const enrolledIncrement = Math.ceil(targetEnrolled / enrolledSteps);
        const certifiedIncrement = Math.ceil(targetCertified / certifiedSteps);

        // Set up interval for enrolled counter
        const enrolledInterval = setInterval(() => {
            setEnrolledCount(prev => {
                if (prev >= targetEnrolled) {
                    clearInterval(enrolledInterval);
                    return targetEnrolled;
                }
                return prev + enrolledIncrement;
            });
        }, increment);

        // Set up interval for certified counter
        const certifiedInterval = setInterval(() => {
            setCertifiedCount(prev => {
                if (prev >= targetCertified) {
                    clearInterval(certifiedInterval);
                    return targetCertified;
                }
                return prev + certifiedIncrement;
            });
        }, increment);

        // Clean up intervals on component unmount
        return () => {
            clearInterval(enrolledInterval);
            clearInterval(certifiedInterval);
        };
    }, []);

    return (
        <>


            {/* Hero Section */}
            <div className="hero-section" id="home">
                <div className="container">
                    <div className="row align-items-center h-100">
                        <div className="col-lg-7 hero-content " data-aos="fade-right">
                            <h1>Online Certificate Programmes</h1>
                            <p className="subtitle">An e-course, or online course, delivers educational content through digital media, allowing learners to access materials and participate in learning activities remotely. E-course content can encompass a variety of formats, including videos, text-based lessons, interactive activities, and assessments, designed to engage learners and facilitate knowledge acquisition</p>

                            <div className="stats-container">
                                <div className="stat-item">
                                    <FontAwesomeIcon icon={faUserGraduate} className="stat-icon" />
                                    <div>
                                        <span className="stat-number">{enrolledCount.toLocaleString()}+</span>
                                        <span className="stat-label">Students Enrolled</span>
                                    </div>
                                </div>
                                <div className="stat-item">
                                    <FontAwesomeIcon icon={faCertificate} className="stat-icon" />
                                    <div>
                                        <span className="stat-number">{certifiedCount.toLocaleString()}+</span>
                                        <span className="stat-label">Certified Students</span>
                                    </div>
                                </div>
                            </div>
                            <div className="cta-buttons1">
                                <button className="btn-explore" onClick={handleScroll}>
                                    Explore Courses</button>
                                {/* <button className="btn-demo">Free Demo</button> */}
                            </div>
                        </div>
                        {/* <div  className="col-lg-1"></div> */}
                        <div className="col-lg-5" data-aos="fade-left">
                            <div className="hero-image-container">
                                <img
                                    src={Landing}
                                    alt="Registration"
                                    className="hero-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

// Image Carousel Component
// Image Carousel Component


export default Header;